/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const UnpluggedIcon: React.FC<AllieIconProps> = (props) => (
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* Background circle */}
    <circle cx="60" cy="60" r="60" fill="white" stroke="#e9ecef" strokeWidth="1"/>
    
    {/* Plug body - outline only with medium stroke */}
    <rect x="38" y="40" width="28" height="22" rx="3" fill="none" stroke="#333333" strokeWidth="3"/>
    
    {/* Plug prongs - simple lines, more separated */}
    <line x1="46" y1="28" x2="46" y2="40" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
    <line x1="58" y1="28" x2="58" y2="40" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
    
    {/* Plug cord - straight line with medium stroke */}
    <line x1="52" y1="62" x2="52" y2="82" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
    
    {/* X mark positioned to the right, slightly lower */}
    <path d="M70 75L78 83M78 75L70 83" stroke="#333333" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);